import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { saveBenchmarkComparisons } from "../../api/estimates/EstimateBenchmarkAPI";
import Spinner from "../common/Spinner";
import { hasRoles } from "../../utils/roles";

/// props validation | SQ(javascript:S6774)
Toggle.propTypes = {
  isAnonymous: PropTypes.bool,
  benchmarkId: PropTypes.string,
  comparisonId: PropTypes.string,
  linkedBenchmarksIds: PropTypes.array,
};

/// props validation | SQ(javascript:S6774)
ToggleWrapper.propTypes = {
  name: PropTypes.string,
  showToggle: PropTypes.bool,
  isAnonymous: PropTypes.bool,
  isRealNameHidden: PropTypes.bool,
  user: PropTypes.object,
};
///
export default function ToggleWrapper(props) {
  const { name, showToggle } = props;
  const { isAnonymous } = props;
  const { isRealNameHidden } = props;
  const { user } = props;

  if (hasRoles(user.roles, ["Client"])) {
    return null;
  }

  return (
    <div className="toggle-wrapper">
      {showToggle && (
        <div className="toggle-container">
          <Toggle {...props} />
        </div>
      )}
      {!isRealNameHidden && (
        <div className="toggle-hidden-name">{isAnonymous ? name : ""}</div>
      )}
    </div>
  );
}

Toggle.propTypes = {
  isLocked: PropTypes.bool,
  setIsLocked: PropTypes.func,
  isAnonymous: PropTypes.bool,
  updateState: PropTypes.func,
};

function Toggle(props) {
  const { isAnonymous: setting } = props;
  const { benchmarkId, comparisonId } = props;
  const { linkedBenchmarksIds } = props;
  const { updateState } = props;

  const { isLocked, setIsLocked } = props;

  const [state, setState] = useState(setting);

  useEffect(() => {
    setState(setting);
  }, [setting]);

  // Only unlock when the data loads
  useEffect(() => {
    setIsLocked(false);
  }, [linkedBenchmarksIds, setIsLocked]);

  const tooltip = state ? "Anonymous" : "Identified";

  if (!isLocked) {
    return (
      <label className="table-switch">
        <input
          type="checkbox"
          checked={!state}
          onChange={async () => {
            setIsLocked(true);
            const isAnonymous = !state;
            setState(isAnonymous);

            await saveBenchmarkComparisons(
              benchmarkId,
              linkedBenchmarksIds,
              comparisonId,
              isAnonymous
            );
            updateState();
          }}
        />
        <span className={"slider round"} title={tooltip} />{" "}
      </label>
    );
  } else {
    return <Spinner marginLeft={"10px"} width={"20px"}></Spinner>;
  }
}
